import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Row, Col, Modal, Dropdown, Badge, Button, Table } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Docmnt from '../../../../assets/images/google-docs.png';
import Chat from '../../../../assets/images/chat.png';
import Rapdf from "../../../../assets/images/pdf.png";
import Trash from "../../../../assets/images/trash.png";
import pen from "../../../../assets/images/pen.png";
import editpen from "../../../../assets/images/edit.png";
import Linktab from "../../../../assets/images/linktab.png";
import Arcv from "../../../../assets/images/archive.svg";
import { Link, useHistory } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import { withRFSToken } from '../../../../Services/axios';
import { toast } from 'react-toastify';
import GalleryView from './Common/GalleryView.js';

import screeninggreen from "../../../../assets/images/screening_green.png";
import screeninggrey from "../../../../assets/images/screening_grey.png";
import securitygreen from "../../../../assets/images/security_green.png";
import securityred from "../../../../assets/images/security_red.png";

import greencheck from "../../../../assets/images/green_check.png"; 
import greycheck from "../../../../assets/images/grey_check.png";
import orangecheck from "../../../../assets/images/orange_check.png";
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const ExportInStock = () => {

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const isMounted = useRef(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ pos: '', awbId: [], airwaybill: '', cutOffTime: '' });
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [gridData, setGridData] = useState({
    Active: [],
    Archived: [],
    // Trash: []

  });
  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    isMounted.current = true;
  }, []);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);
  const [gridreceipt, setGridReceipt] = useState();


  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }
  const handleDropdownItemClick = () => {

  }

  const [galleryOpen, setGalleryOpen] = useState(false);
  const showGalleryModal = () => {
    setGalleryOpen(true);
  };
  const closeGalleryModal = () => {
    setGalleryOpen(false);
  };

  const [showChecksModal, setShowChecksModal] = useState(false);
  const [checksFormData, setChecksFormData] = useState({});
  const [checksRecordId, setChecksRecordId] = useState(null);
  const [isLoadingChecks, setIsLoadingChecks] = useState(false);
  const [checksModalType, setChecksModalType] = useState("checks");

  const openChecksModal = async (recordData, type = "checks") => {
    setChecksModalType(type);
    setShowChecksModal(true);
    setIsLoadingChecks(true);
    let existingData = {};
    try {
      if (recordData.forwarder_export_shipment_record) {
        existingData = recordData.forwarder_export_shipment_record;
        console.log("existingData", existingData);
      }
    } catch (error) {
      console.error("Error parsing forwarder_export_shipment_record:", error);
    }

    setChecksFormData({
      export_shipment_record_id: [existingData?.id],
      sec_status: existingData?.sec_status || recordData.sec_status,
      screening: existingData?.screening || recordData.screening,
      screening_date: existingData?.screening_date,
    });
    
    setIsLoadingChecks(false);
  };

  const closeChecksModal = () => {
    setShowChecksModal(false);
    setChecksFormData({});
    setChecksRecordId(null);
  };

  const handleChecksInputChange = (name, value) => {
    if (name === "screening") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          screening: value,
          screening_date: formattedDate,
          sec_status : "K"
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          screening: value,
          screening_date: "",
          sec_status : "U"
        });
      }
      return;
    }
      else if (name === "sec_status") {
        if (value === "K") {
        setChecksFormData({
          ...checksFormData,
          sec_status : "K"
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          sec_status : "U"
        });
      }
      return;
    }
    setChecksFormData({
      ...checksFormData,
      [name]: value,
    });
  };

  const handleChecksSave = async () => {
    try {
      const res = await withRFSToken.post(
        "shipment/set-shipment-check",
        checksFormData
      );
      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg || "Updated successfully");
        closeChecksModal();
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      } else {
        toast.error(res.data.response_msg || "Failed to update");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to update");
    }
  };

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'awbId', type: 'string' },
          { name: 'airwaybill_no', type: 'string' },
          { name: 'take_in', type: 'date' },
          { name: 'location', type: 'string' },
          { name: 'receipt', type: 'string' },
          { name: 'destination', type: 'string' },
          { name: 'label', type: 'string' },
          { name: 'pick_status', type: 'string' },
          { name: 'cutoff_datetime', type: 'string' },
          { name: 'cutt_off_date', type: 'string' },
          { name: 'bonded', type: 'string' },
          { name: 'label_id', type: 'string' },
          { name: 'shipment_id', type: 'string' },
          { name: 'expected_pieces', type: 'string' },
          { name: 'expected_weight', type: 'string' },
          { name: 'received_pieces', type: 'string' },
          { name: 'received_weight', type: 'string' },
          { name: 'shipper_name', type: 'string' },
          { name: 'shipper_city', type: 'string' },
          { name: 'address_lbl', type: 'string' },
          { name: 'dg', type: 'string' },
          { name: 'dg_lbl', type: 'string' },
          { name: 'security', type: 'string' },
          { name: 'damage', type: 'string' },
          { name: 'remarks', type: 'string' },
          { name: 'accepted_by', type: 'string' },
          { name: 'station', type: 'string' },
          { name: 'record_id', type: 'string' },
          { name: 'sec_status', type: 'string' },
          { name: 'screening', type: 'string' },
          { name: 'check_status_color', type: 'string' },
          { name: 'forwarder_export_shipment_record', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}shipment-export/in-stock?type=${tabType}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
          },
          width: '3%', filterable: false,
        },
        { text: 'Take In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_in', width: '6%', cellclassname: '',},
        { text: 'Record ID', filtertype: 'input', datafield: 'record_id', width: '7%', cellclassname: '', },
        { text: 'Label ID', filtertype: 'input', datafield: 'label_id', width: '9%', cellclassname: '', },
        { text: 'Shipment ID', filtertype: 'input', datafield: 'shipment_id', width: '7%', cellclassname: '', },
        { text: 'Shipper Name', filtertype: 'input', datafield: 'shipper_name', width: '6%', cellclassname: '', },
        { text: 'Destination', filtertype: 'input', datafield: 'destination', width: '6%', cellclassname: '', },
        { text: 'Shipper City', filtertype: 'input', datafield: 'shipper_city', width: '5%', cellclassname: '', },
        
        // { text: 'Outbound', filtertype: 'textbox', width: '4%', cellclassname: '', 
        //    cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
        //     if (rowData.record_id != null && rowData.forwarder_export_shipment_record?.master_airwaybill != null)
        //      return ` <div class="jqx-grid-cell-left-align" style="margin-top:13px;color: green !important;">
        //                 Yes
        //             </div>`;
        //     else 
        //       return "";
        //    }
        // },
        {
          text: 'Airwaybill No', filtertype: 'input', width: '6%', cellclassname: '', datafield: 'airwaybill_no',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
            if (cellValue) {
              defaultHtml = '<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class=""></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return defaultHtml;
          },
        },
        { text: 'LAT', filtertype: 'input', datafield: 'cutoff_datetime', width: '5%', cellclassname: '',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
              if (cellValue) {
                  const formatedDate = cellValue?.split('T')[0]
                  return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
              } else {
                  return '';
              }
          },
        },
        { text: 'Pick Status', filtertype: 'checkedlist', datafield: 'pick_status', width: '6%',
          filteritems: [
            { label: 'Open', value: 'Open' },
            { label: 'Progress', value: 'Progress' },
            { label: 'Complete', value: 'Complete' },
            { label: 'Incomplete', value: 'Incomplete' },
          ],
          cellclassname: (row, column, value, rowData, cellvalue) => {
            if (rowData.pick_status == 'Completed') {
              return "awb_green";
            } else if (rowData.pick_status == 'Incomplete') {
              return "awb_red";
            } else if (rowData.pick_status == 'Progress') {
              return "awb_orange";
            } else if (rowData.pick_status == 'Open') {
              return "awb_blue";
            } else if (rowData.pick_status == 'Initiated') {
              return "awb_sky";
            } else {
              return;
            }
          },
        },
        { text: 'Location', filtertype: 'input', datafield: 'location', width: '5%', cellclassname: '', },
        { text: 'Bonded', filtertype: 'input', datafield: 'bonded', width: '3%', cellclassname: '', },
        // { text: "Screening", datafield: "screening", filtertype: "input", width: "4%", cellclassname: "screening-clickable",
        //   cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
        //     const rowId = rowData?.id || rowData?.bounddata?.id || "";
        //     const iconSrc = cellValue === "1" ? screeninggreen : screeninggrey;
        //     if (rowData.record_id != null)
        //     return `<div style="margin-left:10px; margin-top:13px; cursor: pointer;" class="screening-cell" data-row-id="${rowId}">
        //                 <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
        //             </div>`;
        //     else 
        //       return "";
        //   },
        // },
        {
            text: "Security Status",
            datafield: "sec_status",
            filterable: false,
            width: "6%",
            cellclassname: "sec-status-clickable",
            cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowId = rowData?.id || rowData?.bounddata?.id || "";

                let iconSrc = securityred; // default

                if (rowData?.screening == 1) {
                    iconSrc = securityred;
                } else if (cellValue === "K") {
                    iconSrc = securitygreen;
                } else if (cellValue === "U") {
                    iconSrc = securityred;
                }

                return `
                    <div style="margin-left:10px; margin-top:13px; cursor:pointer;" class="sec-status-cell" data-row-id="${rowId}">
                        <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
                    </div>
                `;
            },
        },
        { text: 'Expected pcs', filtertype: 'input', datafield: 'expected_pieces', width: '5%', cellclassname: '', },
        { text: 'Expected wgt', filtertype: 'input', datafield: 'expected_weight', width: '5%', cellclassname: '', },
        { text: 'Recieved pcs', filtertype: 'input', datafield: 'received_pieces', width: '5%', cellclassname: '', },
        { text: 'Recieve wgt', filtertype: 'input', datafield: 'received_weight', width: '5%', cellclassname: '', },
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        ready: function () {
          localStorgeFilter();
        },
        // rendered: function () {
        //   const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            const dataToSend = {
              uld_number: rowData.uld_number,
              type_code: rowData.type_code,
              serial_number: rowData.serial_number,
              owner_code: rowData.owner_code,
              condition_code: rowData.condition_code,
              asset_type: rowData.asset_type == 'Y' ? false : true
            };
            loadDetails(rowData.awbId, 'E');
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
      });
      window.$(gridRefs[activeTab].current).on('click', '.row_record_redirect', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            const filter = [{
              datafield: "cargohub_id",
              filters: [{
                condition: "CONTAINS",
                operator: 1,
                value: rowData.record_id
              }]
            }];
            localStorage.setItem('srFilter', JSON.stringify(filter));
           history.push("/ForwarderShipments/ShipmentRecords");
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }

      });
      window.$(gridRefs[activeTab].current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        console.log('rowData', rowData);

        if (rowData.airwaybill_no !== null) {
          let formattedCutoffDatetime = null;
          if (rowData.cutoff_datetime instanceof Date && !isNaN(rowData.cutoff_datetime)) {
            formattedCutoffDatetime = rowData.cutoff_datetime.toISOString().slice(0, 16);
          } else if (typeof rowData.cutoff_datetime === "string") {
            formattedCutoffDatetime = rowData.cutoff_datetime;
          }
          handleSetAwb('G', rowData.awbId, rowData.airwaybill_no, rowData.cutoff_datetime)
        } else {
          handleSetAwb('G', rowData.awbId)
        }
      });

      window.$(gridRefs[activeTab].current).on("click", ".screening-cell", function (e) {
        e.stopPropagation();
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        if (rowIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData && rowData.record_id) {
            openChecksModal(rowData, "screening");
          }
        }
      });

      window.$(gridRefs[activeTab].current).on("click", ".sec-status-cell", function (e) {
        e.stopPropagation();
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        if (rowIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData && rowData.record_id) {
            openChecksModal(rowData, "sec_status");
          }
        }
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          console.log("🚀 ~ window.$ ~ selectedRow:", selectedRow)
          const uldNumber = selectedRow.awbId;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // console.log(checkUlds);
          // if (!gridSelect.some(row => row.awbId === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.awbId === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.awbId;
          setGridSelect(prevSelection => prevSelection.filter(row => row.awbId !== unselectedRowId));
          // if(filterForCheck!=true){
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
          // }
          // console.log(checkUlds);

        }
      });
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
       setGridReceipt(args?.receipt);
        if (event.args.columnindex > 1 && event.args.columnindex !== 9 && event.args.columnindex !== 14 && event.args.columnindex !== 15) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          loadDetails(args.awbId);
          // setSelectedRowData(args);
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
          }, 30);
        }
      });
      // }
    }
  }, [gridData]);

  function localStorgeFilter() {
    let savedFilters = localStorage.getItem('srFilter');
    if (savedFilters) {
      savedFilters = JSON.parse(localStorage.getItem('srFilter'));
      savedFilters.forEach(element => {
        const filterValue = element.filters[0].value;
        if (filterValue !== null && filterValue !== undefined) {
          const filterGroup = new window.$.jqx.filter();
          const filterCondition = element.filters[0].condition ?? "CONTAINS"; // Adjust the condition as needed
          const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
          filterGroup.addfilter(1, filter);
          window.$(gridRefs[activeTab].current).jqxGrid("addfilter", element.datafield, filterGroup);
        }
      });
      window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
      localStorage.removeItem("srFilter");
    }
  };
  // const loadDetails = async (id, pos) => {
  //   try {
  //     const res = await withRFSToken.get(`shipment-export/get-cargo-details/${id}`, {})
  //       .then(function (res) {
  //         const innerData = res.data.response_data;
  //         if (pos === 'E') {
  //           localStorage.setItem('EditCargo', JSON.stringify(innerData));
  //           localStorage.setItem('ccbackUrl', JSON.stringify('/ForwarderShipments/Export'));
  //           history.push('/ForwarderShipments/CreateCargo')
  //         } else {
  //           setSelectedRowData(innerData);

  //           setTimeout(() => {
  //             window.$(gridRefs[activeTab].current).jqxGrid('refresh');
  //           }, 30);
  //         }

  //       });
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }
  const loadDetails = async (id, pos) => {
    let endPoint;
    if (pos == 'E') {
      endPoint = `shipment-export/get-cargo-details/${id}`
    } else {
      endPoint = `shipment-export/get-export-details/${id}`
    }
    try {
      const res = await withRFSToken.get(endPoint, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          if (pos === 'E') {
            localStorage.setItem('EditCargo', JSON.stringify(innerData));
            localStorage.setItem('ccbackUrl', JSON.stringify('/ForwarderShipments/Export'));
            history.push('/ForwarderShipments/CreateCargo')
          } else {
            setSelectedRowData(innerData);

            setTimeout(() => {
              window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            }, 30);
          }

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };

  const handleSetAwb = (pos, id, awb, cut) => {
    // console.log("🚀 ~ handleSetAwb ~ ids:", ids)
    if (pos === 'T') {
      if (gridSelect.length > 0) {
        const ids = gridSelect?.map(ids => ({ ids: ids.awbId, labelId: ids.label_id }));
        setModalData({ pos: pos, awbId: ids, airwaybill: awb || '', cutOffTime: cut || getCurrentDateTime() })
        setIsModal(true)
      } else {
        toast.error('Please select at least one row');
      }
    } else if (pos === 'G') {
      console.log('s1', cut);
      if (cut) {
        console.log('s');

        setModalData({ pos: pos, awbId: [id], airwaybill: awb || '', cutOffTime: cut })
      } else {
        setModalData({ pos: pos, awbId: [id], airwaybill: awb || '', cutOffTime: getCurrentDateTime() })
      }
      setIsModal(true)
    }
  }
  const modalInputChange = (name, value) => {
    if (name === 'airwaybill') {
      value = handleChange(value);
    }
    setModalData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }
  const handleChange = (value) => {
    value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
    let formattedValue = '';

    // Add a hyphen after the third character
    if (value.length > 3) {
      formattedValue += value.substr(0, 3) + '-';
      value = value.substr(3);
    }

    // Add a space after the eighth character
    if (value.length > 4) {
      formattedValue += value.substr(0, 4) + ' ';
      value = value.substr(4);
    }

    formattedValue += value;
    return formattedValue.substr(0, 13);
  };

  const removeAwb = (id) => {
    setModalData(prevFormData => {
      const newUldInfo = prevFormData.awbId.filter(stack => stack.ids !== id);
      return { ...prevFormData, awbId: newUldInfo };
    });
  };

  const [actArcModal, setActArcModal] = useState(false);
  const handleMoveToActArc = () => {
    if (gridSelect.length <= 0) {
      toast.error('Please select grid data before send');
    } else {
      setActArcModal(true);
      // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
    }
  };
  const confirmMoveToActArc = async () => {
    // console.log('101', gridSelect);
    const sendAction = activeTab == 'Active' ? 'R' : 'A';
    const uldNumbers = gridSelect && gridSelect.map(num => num.awbId)
    try {
      const res = await withRFSToken.post('shipment-export/move-to-archive', { awbId: uldNumbers })
        .then(function (res) {
          if (res.data.response_code == 200) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            // setGridSelect([]);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            // fetchDataGrid()
            // if (activeTab == 'Active') {
            //     toast.success('ULD Data moved to Arhive');
            //     fetchDataGrid()
            // } else {
            //     toast.success('ULD Data moved to Active');
            //     fetchDataGridR()
            // }
            setActArcModal(false)
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const validateFormData = () => {
    let isValid = true;

    // Validate status
    if (!modalData.airwaybill) {
      toast.error('Please insert Airway Bill')
      isValid = false;
    }
    if (modalData.airwaybill.length !== 13) {
      toast.error('The air way bill must be like 000-0000 0000')
      isValid = false;
    }
    // Validate destination
    else if (!modalData.cutOffTime) {
      toast.error('Please insert Cutt Off Date');
      isValid = false;
    }
    // Validate uldInfo array
    return isValid;
  };

  const updateSetAwb = async () => {
    if (modalData.airwaybill.length === 13) {
      let airId = [];
      if (modalData.pos === 'T') {
        airId = modalData.awbId.map(id => id.ids);
      } else {
        airId = modalData.awbId;
      }
      const payload = {
        awbId: airId,
        airwaybill: modalData.airwaybill,
        cutOffTime: modalData.cutOffTime
      }

      try {
        const res = await withRFSToken.post('shipment-export/set-airwaybill', payload);
        if (res.data.response_code == 200) {
          toast.success(res.data.response_msg);
          setGridSelect([]);
          isModalClose();
          setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
          }, 1);
          setGridSelect([])
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      toast.error('The air way bill must be like 000-0000 0000')
    }
  }
  const isModalClose = () => {
    setIsModal(false);
    setModalData({ pos: '', awbId: [], airwaybill: '', cutOffTime: getCurrentDateTime() })
  }


  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  // const handleFileChange = (e) => {
  //     const selectedFiles = Array.from(e.target.files);
  //     const filesWithBase64 = [];
  //     selectedFiles.forEach((file) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             filesWithBase64.push({ file, base64: reader.result });
  //             if (filesWithBase64.length === selectedFiles.length) {
  //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

  //             }
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // }
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  // +++++++++++++++++++++++++++++++++++ Silk Slider
  // const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
  const findPrimary = selectedRowData?.attachments;
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };
  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Export');
    history.push('/ForwarderShipments/CreateCargo');
  }

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };
   const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);
  const handleDisconnectClick = () => {
      if (gridSelect.length === 0) {
        toast.error("Please select at least one record from the nested grid");
        return;
      }
      setShowDisconnectConfirm(true);
    };
   const handleConfirmDisconnect = async () => {
      setShowDisconnectConfirm(false);
      const selectedIds = gridSelect.map((data) => data.awbId);
      console.log("Disconnecting IDs:", selectedIds);
  
      try {
        const res = await withRFSToken.post("shipment/disconnect-airway-bill", {
          take_in_ids: selectedIds,
        });
  
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg || "Records disconnected successfully");
          setGridSelect([]);
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
          gridSelect.forEach(item => {
          const selectedRowBoundIndex = item.boundindex;
          window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        });
        } else {
          toast.error(res.data.response_msg || "Failed to disconnect records");
        }
      } catch (error) {
        console.error("Error disconnecting records:", error);
        toast.success("Dummy Disconnect Success (API likely not found)");
        setGridSelect([]);
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      }
    };


  return (
    <>
      {galleryOpen && <GalleryView attachments={selectedRowData.attachments} attachment_sec='oa' onClose={closeGalleryModal} />}
      <div className="mb-3 nestedtabs rounded minh">
        <div className='d-flex'>
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
              <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
               <Dropdown.Item onClick={() => handleDisconnectClick()}>Disconnect</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
         
            <div className='ulddown'>
              <button onClick={handleMoveToActArc}> <img title='' src={Arcv} />{activeTab === 'Active' ? 'Archive' : 'Active'}</button>
              
            </div>
          
        </div>
      </div>
      <div className="maindiv">
        <div className='trashdonload'>
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
            <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              }
              {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
            </Tab>
            <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
              {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
            </Tab>
          </Tabs>
        </div>
        {selectedRowData && (
          <div className='SecondDiv mt-45'>
            {/* {console.log('55', selectedRowData)} */}
            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
            <div className='girddtals_header'>
              <h3>
                {selectedRowData.label_id} &nbsp; <span>{selectedRowData.status}</span>
              </h3>
              <div className='d-flex actbtn'>
                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
              </div>

            </div>
            <div className='mt-3'>
              <div className='mb-3'>
                <h3>Highlighted Image(s)</h3>
                {selectedRowData?.attachments && (
                  <>
                    <div className="g_parent">
                      {findPrimary.slice(0, 5).map((file, index) => {
                        let classN = '';
                        if (findPrimary.length === 1) {
                          classN = 'double'
                        } else if (findPrimary.length === 2) {
                          classN = 'double'
                        } else if (findPrimary.length === 3) {
                          classN = 'third'
                        } else if (findPrimary.length > 3) {
                          classN = 'more'
                        }
                        return (
                          <>
                            <div className={`${classN}${index + 1}`}>
                              <img
                                src={file.file_path}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",

                                }}

                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                onClick={() =>
                                  handleFileClick(file.file_path)
                                }
                              />
                            </div>
                          </>
                        )
                      })}
                      {findPrimary.length > 5 && (
                        <div className='more'>
                          <button className="more-btn" onClick={showGalleryModal}>
                            +{findPrimary.length - 5}
                          </button>
                        </div>
                      )}
                    </div>

                    {/* <div className='main_primary shipment_gl'>
                      {findPrimary.slice(0, 4).map((file, index) => {
                        const fileName = file?.file_name;
                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                        const extension = fileName?.split(".").pop();
                        return (
                          <>
                            <div key={`ns_${index}`} className='primary_image'>
                              {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                              ) ? (
                                <>
                                  {console.log('findPrimary', findPrimary.length)}

                                  <div className={index === 0 ? 'g_big' : ''}>
                                    <img
                                      src={file.file_path}
                                      alt="Preview"
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",

                                      }}

                                      // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                      onClick={() =>
                                        handleFileClick(file.file_path)
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <span className="">
                                    <img src={Docmnt} className="fileimg" />
                                  </span>
                                </>
                              )}
                              <span className="rafilename">
                                {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                              </span>
                            </div>
                          </>
                        );
                      })}
                      {findPrimary.length > 4 && (
                        <div className='more'>
                          <button className="more-btn" onClick={showGalleryModal}>
                            +{findPrimary.length - 4}
                          </button>
                        </div>
                      )}
                    </div> */}
                  </>
                )}
              </div>
              <div>
                <h3>Receipt</h3>
                {gridreceipt && (
                  <div style={{ textAlign: 'left', padding: '5px' }}>
                    <a target='_blank' rel="noopener noreferrer" href={gridreceipt}>
                      <img style={{ width: '35px', cursor: 'pointer' }} src={Rapdf} alt="Receipt PDF" />
                    </a>
                  </div>
                )}
                {!gridreceipt&& (
                  <p style={{ textAlign: 'center', color: '#999' }}>No receipt available</p>
                )}
              </div>
              <div>
                <h3>Shipment Information</h3>
                <ul className='truck_info'>
                  <li><span>Address LBL :</span> <span>{selectedRowData.address_lbl}</span></li>
                  <li><span>DG :</span> <span>{selectedRowData.dg}</span></li>
                  <li><span>DG LBL :</span> <span>{selectedRowData.dg_lbl}</span></li>
                  <li><span>Accepted By :</span> <span>{selectedRowData.accepted_by}</span></li>
                  <li><span>Security :</span> <span>{selectedRowData.security}</span></li>
                  <li><span>Remarks :</span> <span>{selectedRowData.remarks}</span></li>
                  <li><span>Damage :</span> <span>{selectedRowData.damage}</span></li>
                  <li><span>Station :</span> <span>{selectedRowData.station}</span></li>

                </ul>
              </div>
            </div>

            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"einstock"}
              attachable_id={selectedRowData.awbId}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.awbId)}
            />
            <ActivityComments
              commentable_type={"einstock"}
              commentable_id={selectedRowData.awbId}
              allactivities={selectedRowData.activities}
              onReloadDetails={loadDetails}
            />
          </div>
        )}
      </div>
      <Modal show={isModal} onHide={!isSaving ? isModalClose : null} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Set Airwaybill</h3>
          {/* <p>If you proceed with the change, user data will be removed. <br /> Are you sure you want to continue? </p> */}
          <div className='saairbill mb-2'>
            <Form.Label>Airway Bill Number<span>*</span></Form.Label>
            <Form.Control type="text"
              name='airwaybill'
              value={modalData.airwaybill || ''}
              maxLength={13}
              placeholder='000-0000 0000'
              // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
              onChange={(e) => modalInputChange('airwaybill', e.target.value)}
            />
          </div>
          <div className='saairbill'>
            <Form.Label>Cut Off Date<span>*</span></Form.Label>
            <Form.Control
              type="datetime-local" name='cutOffTime'
              value={modalData?.cutOffTime ? modalData.cutOffTime : getCurrentDateTime()}
              onChange={(e) => modalInputChange('cutOffTime', e.target.value)}
            />
          </div>
          {modalData.pos === 'T' &&
            <>
              <Table striped className='uldlist'>
                <thead>
                  <tr>
                    <th>Label Id</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData.awbId.map((data, index) => (
                    <tr key={index}>
                      <td>{data.labelId}</td>
                      <td>
                        {modalData.awbId.length > 1 &&
                          <button style={{ border: 'none', background: 'none' }} onClick={() => removeAwb(data.ids)}>
                            <img title="" src={Trash} />
                          </button>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger" disabled={isSaving} className='position-relative' onClick={isModalClose}>
            Cancel
          </Button> */}
          <Button variant="primary" disabled={isSaving} className='position-relative' onClick={updateSetAwb}>
            {isSaving ? <>Updating...<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Update'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Selected {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
          <p>Are you sure you want to move {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => setActArcModal(false)}>
              No
            </Button>
            <Button variant="primary" onClick={confirmMoveToActArc}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose} centered className="imgmodal">
        <Modal.Header closeButton onClick={handleClose}></Modal.Header>
        <Modal.Body>
          {/* {console.log(selectedFile)} */}
          <img src={selectedFile} className="img-fluid" alt="Selected" />
        </Modal.Body>
      </Modal>
      <Modal
        className="addfrom change_type"
        show={showChecksModal}
        onHide={closeChecksModal}
        centered
        size={checksModalType === "sec_status" ? "md" : "lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {checksModalType === "checks"
              ? "Checks"
              : checksModalType === "screening"
                ? "Screening"
                : "Security Status"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingChecks ? (
            <div className="text-center p-4">Loading...</div>
          ) : (
            <div className="flbg details h-100 record_export_modal">
              <ul className="checks">
                {/* Show only Screening field when screening modal type */}
                {checksModalType === "screening" && (
                  <li>
                    <span className="d-flex align-items-base-line justify-content-between gap-3">
                      <span style={{ minWidth: "180px", color: "inherit" }}>
                        Screening :
                      </span>
                      <span className="d-flex" style={{ minWidth: "220px" }}>
                        <Form.Check
                          inline
                          type="radio"
                          label="Yes"
                          name="screening"
                          checked={checksFormData.screening == "1"}
                          onChange={() =>
                            handleChecksInputChange("screening", "1")
                          }
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="No"
                          name="screening"
                          checked={checksFormData.screening == "0"}
                          onChange={() =>
                            handleChecksInputChange("screening", "0")
                          }
                        />
                      </span>
                      <Form.Control
                        type="datetime-local"
                        name="screening_date"
                        value={checksFormData?.screening_date || ""}
                        onChange={(e) =>
                          handleChecksInputChange(
                            "screening_date",
                            e.target.value
                          )
                        }
                        style={{ maxWidth: "230px" }}
                        className="date_picker"
                      />
                    </span>
                  </li>
                )}

                {/* Show only Sec Status field when sec_status modal type */}
                {checksModalType === "sec_status" && (
                  <li className="">
                    <span className="d-flex align-items-base-line justify-content-between gap-3">
                      <span style={{ minWidth: "170px", color: "inherit" }}>
                        Security Status :
                      </span>
                      <span className="d-flex" style={{ minWidth: "220px" }}>
                        <Form.Check
                          inline
                          type="radio"
                          label="Known"
                          id="Known-1"
                          name="sec_status"
                          value="K"
                          checked={checksFormData?.sec_status === "K"}
                          onChange={(e) =>
                            handleChecksInputChange("sec_status", "K")
                          }
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="Unknown"
                          id="Known-2"
                          name="sec_status"
                          value="U"
                          checked={checksFormData?.sec_status === "U"}
                          onChange={(e) =>
                            handleChecksInputChange("sec_status", "U")
                          }
                        />
                      </span>
                    </span>
                  </li>
                )}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeChecksModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleChecksSave}
              disabled={isLoadingChecks}
            >
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
       <Modal className="raintrac" show={showDisconnectConfirm} onHide={() => setShowDisconnectConfirm(false)} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h2>Confirm Disconnect</h2>
          <p>
            {gridSelect.length} record
            {gridSelect.length > 1 ? "s" : ""} will be disconnected.
            <br />
            Are you sure you want to continue?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDisconnectConfirm(false)}>
            No
          </Button>
          <Button variant="primary" onClick={handleConfirmDisconnect}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ExportInStock